import { render, staticRenderFns } from "./change-review-modal.vue?vue&type=template&id=6a73d97a"
import script from "./change-review-modal.ts?vue&type=script&lang=ts&external"
export * from "./change-review-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./change-review-modal.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a73d97a')) {
      api.createRecord('6a73d97a', component.options)
    } else {
      api.reload('6a73d97a', component.options)
    }
    module.hot.accept("./change-review-modal.vue?vue&type=template&id=6a73d97a", function () {
      api.rerender('6a73d97a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-input/change-review-modal/change-review-modal.vue"
export default component.exports